import React from "react";
import { Reveal, Kicker, WfButton, Tag } from "@/components/site/primitives";
import { ORG, TIMELINE, PHOTO_CREDIT } from "@/content/worldFarmers";
import { scrollToId } from "@/lib/scrollTo";

export const AboutHistory = () => {
  const go = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };
  return (
    <section
      id="who-we-are"
      aria-labelledby="about-heading"
      className="wf-section bg-[var(--wf-paper)]"
    >
      <div className="wf-container grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
        {/* Archival image */}
        <Reveal className="lg:col-span-5">
          <figure className="group relative">
            <div className="relative rounded-sm bg-[var(--wf-paper)] p-3 shadow-[var(--wf-shadow)] ring-1 ring-[var(--wf-border)] lg:-rotate-1">
              <div className="overflow-hidden">
                <img
                  src="/images/wf/farm-3754.jpg"
                  alt="A black-and-white archival photograph of a worker harvesting vegetables among dense foliage."
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover grayscale"
                />
              </div>
              <figcaption className="flex items-center justify-between px-1 pt-3">
                <span className="font-serif text-sm italic text-[var(--wf-soil)]">From the fields, Lancaster MA</span>
                <a
                  href={PHOTO_CREDIT.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] text-muted-foreground underline decoration-dotted underline-offset-2 hover:text-[var(--wf-maroon)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm"
                >
                  {PHOTO_CREDIT.label}
                </a>
              </figcaption>
            </div>
          </figure>
        </Reveal>

        {/* Narrative */}
        <div className="lg:col-span-7">
          <Reveal>
            <div className="flex items-center gap-3">
              <Kicker>Who we are</Kicker>
              <Tag>Since {ORG.founded}</Tag>
            </div>
            <h2 id="about-heading" className="mt-4 font-serif text-3xl font-semibold leading-tight text-[var(--wf-ink)] sm:text-4xl">
              Four decades of growing farmers, not just crops.
            </h2>
            <p className="mt-5 max-w-[60ch] text-base leading-7 text-muted-foreground">
              {ORG.missionFull}
            </p>
            <blockquote className="mt-6 border-l-2 border-[var(--wf-maroon)] pl-4 font-serif text-lg italic text-[var(--wf-soil)]">
              “All programming happens in a respectful environment of cross-cultural co-learning — among farmers, staff, interns, and volunteers.”
            </blockquote>
          </Reveal>

          {/* Mini timeline */}
          <Reveal delay={0.1}>
            <ol className="mt-8 space-y-4">
              {TIMELINE.map((t) => (
                <li key={t.year} className="flex gap-4">
                  <span className="mt-0.5 w-16 shrink-0 font-serif text-lg font-semibold text-[var(--wf-maroon)]">
                    {t.year}
                  </span>
                  <span className="text-sm leading-6 text-muted-foreground">{t.text}</span>
                </li>
              ))}
            </ol>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-8">
              <WfButton as="a" href="#programs" onClick={go("programs")} withArrow data-testid="about-learn-more-button">
                Explore our programs
              </WfButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
